<template>
    <div>
    <el-breadcrumb separator="/" class="bread">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'menu' }">资源树</el-breadcrumb-item>
        <el-breadcrumb-item>编辑</el-breadcrumb-item>
    </el-breadcrumb>
        <div >
            <el-form :model="form" :rules="menurules" ref="form"  label-width="120px" class="demo-ruleForm"  :label-position="labelposition">
                <el-form-item label="菜单名称" :label-width="formLabelWidth" prop="name">
                    <el-input v-model="form.name" auto-complete="off" ></el-input>
                </el-form-item>
                <el-form-item label="菜单url" :label-width="formLabelWidth" prop="url">
                    <el-input v-model="form.url" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="菜单序号" :label-width="formLabelWidth" prop="order">
                    <el-input v-model="form.order" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="菜单编号" :label-width="formLabelWidth" prop="code">
                    <el-input v-model="form.code" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="菜单描述" :label-width="formLabelWidth">
                    <el-input v-model="form.desc" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="是否是菜单" :label-width="formLabelWidth">
                    <el-switch
                            v-model="form.isMenu"
                            on-color="#13ce66"
                            off-color="#ff4949">
                    </el-switch>

                </el-form-item>
                <!-- 权限设置 -->
                <el-form-item label="Authority Name" :label-width="formLabelWidth">
                    <el-input v-model="form.authorityName" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Authority Url" :label-width="formLabelWidth">
                    <el-input v-model="form.requestUrl" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Authority Method" :label-width="formLabelWidth">
                    <el-input v-model="form.requestMethod" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Authority Params" :label-width="formLabelWidth">
                    <el-input v-model="form.requestParams" auto-complete="off"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button  @click="redrictTree">取 消</el-button>
                    <el-button type="primary" @click="submitForm('form')">确 定</el-button>
                </el-form-item>
            </el-form>

        </div>

    </div>
</template>
<script>
    export  default{
        props: ['id'],
        data(){
            var validateplaybillName = (rule, value, callback) => {
                if(value !== this.name) {
                    this.$http.post(this.requetHost + "/broadcast/playbill/validatePlaybillName", {playbillName: value}).then(response => {
                        if (response.status === 200) {
                            if (response.body.res === "success") {
                                callback(new Error('playbill名称已存在请重新输入！'));
                            } else {
                                callback();
                            }
                        }
                    }, function (response) {
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'
                        });
                    })
                }else{
                    callback();
                }
            };
            return{
                id:"",
                labelposition:"left",
                formLabelWidth: '120px',
                form: {
                    name: '',
                    url: '',
                    order: '',
                    code:'',
                    desc:'',
                    isMenu:'',
                    authorityName:'',
                    requestUrl:'',
                    requestMethod:'',
                    requestParams:''

                },

                menurules: {
                    name: [
                        { required: true, message: '请输入菜单名称', trigger: 'blur' },
                    ],
                   /* url: [
                        { required: true, message: '请输入菜单的url', trigger: 'blur' },
                    ],*/
                    order: [
                        { required: true, message: '请输入同级菜单的顺序', trigger: 'blur' },
                    ],
                    remark: [
                        { min: 0, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
                    ]
                }

            }
        },
        created(){
            console.log("id>>>>>>>>"+this.id);
            this.toUpdate();
//            if(this.$route.params.id>0){
//                this.id=this.$route.params.id;
//                this.toUpdate();
//                //调用查询函数 toUpdate
//            };
        },

        methods: {
            toUpdate(){
                this.$http.get(this.requetHost+'/sys/resource/findById' ,{params:{"resourceId":this.id}})
                    .then(response => {
                            if (response.status === 200) {

                                this.form.name = response.body.sysResource.name;
                                this.form.url = response.body.sysResource.url;
                                this.form.order = response.body.sysResource.ordernum;
                                this.form.code = response.body.sysResource.code;
                                this.form.desc = response.body.sysResource.nodedesc;
                                //this.treedata =  JSON.stringify(tree);
                                this.findeAuthorityByResourcesId();
                                var isMenu=response.body.sysResource.isMenu==1?true:false;
                                this.form.isMenu=isMenu;
                            }else{
                                this.$message({
                                    showClose: true,
                                    message: '节点资源加载不正确',
                                    type: 'error'
                                });
                            }
                        },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        }
                    )


            },
            submitForm(formName){
                debugger;
                this.$http.post(this.requetHost + '/sys/resource/editNode', {
                    resourceId: this.id,
                    menuName: this.form.name,
                    url: this.form.url,
                    order: this.form.order,
                    code: this.form.code,
                    describe: this.form.desc,
                    isMenu:this.form.isMenu?1:0
                })
                    .then(response => {
                            this.loading2 = true;
                            if (response.status === 200) {
                                if (response.body.res == true) {
                                    debugger;
                                    this.$router.push('/content/04/menu');
                                    this.saveAuthority();

                                    setTimeout(() => {
                                        this.loading2 = false;
                                        //this.$router.push('/main');
                                    }, 2000);

                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: '编辑节点失败',
                                        type: 'error'

                                    });
                                }
                            }
                        }, function (response) {
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        }
                    );

            },
            //----------------------权限操作---------------------------//
            findeAuthorityByResourcesId(){
                var _this=this;
                this.$store.dispatch('findeAuthorityByResourcesId',this.id).then((res)=>{
                    if(res.authorityInfo.length>0){
                        var data=res.authorityInfo[0];
                        _this.form.authorityName=data.authority_name;
                        var append="";
                        if(data.authorityUrlList.length>0){
                            for(var i=0;i<data.authorityUrlList.length;i++){
                                if(i>0){
                                    append=",";
                                }
                                _this.form.requestUrl=_this.form.requestUrl+data.authorityUrlList[i].requestUrl+append;
                                _this.form.requestMethod=_this.form.requestMethod+data.authorityUrlList[i].requestMethod+append;
                                _this.form.requestParams=_this.form.requestParams+data.authorityUrlList[i].requestParams+append
                            }
                        }

                    }
                });
            },
            saveAuthority(){
                var _this=this;
                var params={resourcesId:this.id,
                    authorityName:this.form.authorityName,
                    requestUrl:this.form.requestUrl,
                    requestMethod:this.form.requestMethod,
                    requestParams:this.form.requestParams
                }
                this.$store.dispatch('saveAuthority',params).then((res)=>{
                    _this.status=res.status;
                });
            },
            redrictTree(){
                this.$router.push('/content/04/menu');
            }




        }
    }
</script>
<style>

</style>


// WEBPACK FOOTER //
// MenuEdit.vue?08ba86ae